import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import CommonRow from "./common-row";
import ExpandableRow from "./expandable-row";


const Row = ({ row, removeRow }) => {
    const [open, setOpen] = React.useState(false);

    const theme = useTheme();
    const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));

    return (
        <>
            <CommonRow row={row} removeRow={removeRow} open={open} setOpen={setOpen} />
            {!isXlUp && (
                <ExpandableRow row={row} open={open} />
            )}
        </>
    );
};

export default Row;